import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'

export const BrandTabsBlockFragment: BlockFragment = {
  name: 'brandTabs',
  fragment: gql`
    fragment brandTabs on BrandTabs {
      id
      blockName
      blockType
      heading
      showViewAllLink
      brands: liteBrands {
        id
        description
        name
        logo {
          id
          url
          alt
        }
        slug
      }
      limit
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on BrandTabs {
      id
      blockName
      blockType
      heading
      showViewAllLink
      brands: liteBrands {
        id
        name
        description
        logo {
          id
          url
          alt
        }
        slug
      }
      limit
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const BrandTabsBlockType = 'brandTabs'

export interface BrandTabsBlock extends BaseOfferBlock {
  blockType: typeof BrandTabsBlockType
  heading?: string
  showViewAllLink?: boolean
  imagePriority?: boolean
  brands: {
    id: string
    name: string
    description?: string
    logo: {
      id: string
      url: string
      alt: string
    }
    slug: string
  }[]
  limit: number
}
